/* eslint-disable import/no-named-as-default-member */
import { once } from "lodash";
import ReactGA from "react-ga";

function areCookiesEnabled() {
    try {
        document.cookie = "testcookie=test; Max-Age=10; SameSite=Strict;";
        const isEnabled = document.cookie.indexOf("testcookie") !== -1;
        document.cookie = "testcookie=; Max-Age=-1; SameSite=Strict;";
        return isEnabled;
    } catch {
        return false;
    }
}

function getCurrentCleanedUrl(): URL {
    const url = new URL(window.location.href);
    url.searchParams.delete("config_string");
    url.searchParams.delete("encoded_config");
    url.hash = "";
    return url;
}

const GaReporter = {
    enabled: false,

    track(...args: any | any[]) {
        ReactGA.ga.apply(null, args);
    },

    trackPageView() {
        const url = getCurrentCleanedUrl();
        ReactGA.set({ location: url.href });
        GaReporter.track("send", "pageview", { page: url.pathname.toLowerCase() });
    },

    initTracking(trackingId: string, useCookies: boolean, cookiePath: string, appType: string, appVersion: string) {
        const options: any = {
            gaOptions: {},
            // debug: isDev(),
        };

        if (useCookies && areCookiesEnabled()) {
            options.gaOptions.cookieDomain = "auto";
            options.gaOptions.cookiePath = cookiePath;
            options.gaOptions.cookieFlags = "secure;samesite=none";
            ReactGA.initialize(trackingId, options);
            ReactGA.set({ dimension5: "cookie" });
        } else {
            options.gaOptions.storage = "none";
            ReactGA.initialize(trackingId, options);
            ReactGA.set({ dimension5: "none" });
        }

        if (window.location.protocol !== "file:") {
            ReactGA.plugin.require("ec");
        }

        if (window.location.protocol === "file:") ReactGA.set({ checkProtocolTask: null });

        ReactGA.set({ anonymizeIp: true });

        // Application type
        ReactGA.set({ dimension1: appType });

        // Application version
        ReactGA.set({ dimension2: appVersion });

        // Instance ID
        // TODO: Set to the instance ID saved in some file in standalone.
        ReactGA.set({ dimension7: appType });
        GaReporter.enabled = true;
    },

    setProject(project: string) {
        ReactGA.set({ dimension3: project });
    },

    setModelId(modelId: string) {
        ReactGA.set({ dimension4: modelId });
    },

    setAccountId(accountId: string) {
        ReactGA.set({ dimension6: accountId });
    },

    /**
     * Creates a function to use as hitCallback for Google Analytics,
     * with a timeout that triggers the callback anyway in case the
     * analytics call fails or if GaReporter isn't enabled.
     */
    createHitCallback(callback: () => void) {
        const fn = once(callback);
        setTimeout(fn, GaReporter.enabled ? 1000 : 0);
        return fn;
    },
};

export default GaReporter;
